import React from 'react';
import { Alert, Badge, Button, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { statusMeta } from '../config/rateShopConstants';
import { money } from '../lib/describe';
export { dateTime } from '../lib/describe';

export const errorText = value =>
  typeof value === 'string' ? value : value?.message || JSON.stringify(value);

export const StatusBadge = ({ status }) => {
  const meta =
    status === 'unchanged'
      ? { label: 'Unchanged', variant: 'secondary' }
      : statusMeta(status);
  return (
    <Badge
      bg={meta.variant}
      text={meta.variant === 'light' ? 'dark' : undefined}
    >
      {meta.label}
    </Badge>
  );
};

export const Counts = ({ counts = {} }) => (
  <span className="d-inline-flex flex-wrap gap-1">
    {Object.entries(counts).map(([status, count]) => (
      <span key={status}>
        <StatusBadge status={status} />{' '}
        <strong className="me-2">{count}</strong>
      </span>
    ))}
    {!Object.keys(counts).length && (
      <span className="text-muted">No outcomes</span>
    )}
  </span>
);

export const RateLabel = ({ rate, carrier = true }) =>
  rate ? (
    <span className="text-break">
      {carrier && `${rate.carrierCode || rate.carrierId || '—'} · `}
      {rate.serviceCode} · <strong>{money(rate.total)}</strong>
    </span>
  ) : (
    <span className="text-muted">—</span>
  );

export const Loading = ({ label = 'Loading…' }) => (
  <div className="text-center p-4" role="status">
    <Spinner size="sm" animation="border" className="me-2" />
    {label}
  </div>
);
export const LoadError = ({ error }) =>
  error ? <Alert variant="danger">{errorText(error)}</Alert> : null;
export const RefreshButton = ({ onClick, loading }) => (
  <Button
    variant="outline-primary"
    size="sm"
    disabled={loading}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faSyncAlt} className="me-2" />
    Refresh
  </Button>
);

export const ConfirmModal = ({
  show,
  title,
  children,
  onHide,
  onConfirm,
  busy,
  confirmDisabled = false,
  confirmLabel = 'Confirm',
  variant = 'danger'
}) => (
  <Modal
    show={show}
    onHide={busy ? undefined : onHide}
    centered
    backdrop={busy ? 'static' : true}
  >
    <Modal.Header closeButton={!busy}>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={busy}>
        Cancel
      </Button>
      <Button
        variant={variant}
        onClick={onConfirm}
        disabled={busy || confirmDisabled}
      >
        {busy ? 'Working…' : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);
